/* eslint-disable @typescript-eslint/no-explicit-any */
import { BrandSignUpHeader } from "../SignUp/BrandSignUp";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../../Providers/Auth";
import { toast } from "react-toastify";
import mixpanel from "mixpanel-browser";
import { BadgeCheck, Brain, Headphones, Loader2, Settings } from "lucide-react";
import { Button } from "@/shadcnComponents/ui/button";
import { Input } from "@/shadcnComponents/ui/input";
import { Label } from "@/shadcnComponents/ui/label";

export const BrandLogin = () => {
  return (
    <>
      <div className="min-h-screen">
        <BrandSignUpHeader />
        <div className="grid min-h-[calc(100vh-4rem)] grid-cols-1 lg:grid-cols-2">
          <div className="hidden lg:block">
            <div className="flex h-full flex-col justify-between bg-muted p-10">
              <div className="space-y-6">
                <div className="space-y-4">
                  <div className="space-y-2">
                    <h3 className="font-semibold">Recent Success Stories</h3>
                    <div className="space-y-4">
                      <blockquote className="border-l-2 pl-6">
                        anchors' platform has revolutionized how we approach
                        influencer marketing at Bosscoder Academy. Their Deep
                        Insights reports reduced our analysis time by an
                        impressive 70%, enabling us to execute more campaigns
                        with precision and confidence. Thanks to anchors, our
                        LinkedIn influencer marketing efforts have become a key
                        driver of success, significantly boosting efficiency and
                        turning it into an indispensable part of our marketing
                        strategy.
                        <footer className="mt-2 text-sm text-muted-foreground">
                          - Noor, Marketing Head, Bosscoder Academy
                        </footer>
                      </blockquote>
                    </div>
                  </div>
                </div>
              </div>
              <div className="space-y-4">
                <div className="grid grid-cols-2 gap-6">
                  <div className="flex items-start gap-4">
                    <div className="rounded-lg bg-background p-2">
                      <BadgeCheck className="h-6 w-6 text-primary" />
                    </div>
                    <div>
                      <h4 className="font-semibold">Source-of-Truth Data</h4>
                      <p className="text-sm text-muted-foreground">
                        No guesswork ; real influencer insights
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="rounded-lg bg-background p-2">
                      <Settings className="h-6 w-6 text-primary" />
                    </div>
                    <div>
                      <h4 className="font-semibold">Real-time Analytics</h4>
                      <p className="text-sm text-muted-foreground">
                        Track performance live
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="rounded-lg bg-background p-2">
                      <Brain className="h-6 w-6 text-primary" />
                    </div>
                    <div>
                      <h4 className="font-semibold">Smart Matching</h4>
                      <p className="text-sm text-muted-foreground">
                        AI-powered recommendations
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="rounded-lg bg-background p-2">
                      <Headphones className="h-6 w-6 text-primary" />
                    </div>
                    <div>
                      <h4 className="font-semibold">Dedicated Support</h4>
                      <p className="text-sm text-muted-foreground">
                        24/7 expert assistance
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex items-center justify-center p-6">
            <BrandLoginForm />
          </div>
        </div>
      </div>
    </>
  );
};

export function BrandLoginForm() {
  const [isLoading, setIsLoading] = useState(false);
  const [showOTP, setShowOTP] = useState(false);
  const [email, setEmail] = useState("");
  const authState = useAuth();
  const navigate = useNavigate();
  const [Otp, SetOtp] = useState(null);

  if (
    localStorage.getItem("jwtToken") &&
    localStorage.getItem("UserType") === "Brand"
  ) {
    navigate("/Brand/Welcome");
  }
  useEffect(() => {
    mixpanel.track("Page visited Anchors Collab Brand SignIn");
  }, []);

  const handleSendOTP = async () => {
    try {
      if (!email) {
        return toast.error("Please Enter Your Mail", {
          position: "top-center",
          autoClose: 2000,
        });
      }
      setIsLoading(true);
      const mailExist = await authState.getBrandByEmail(email);
      if (mailExist.success) {
        const result = await authState.sendingOTPFeature(email);
        if (result.success) {
          setIsLoading(false);
          mixpanel.track("Requested Otp for Login");
          toast.info("Otp Sent Successfully to your MailBox", {
            position: "top-center",
            autoClose: 2000,
          });
          setShowOTP(true);
        } else {
          setIsLoading(false);
          return toast.error(result.Error, {
            position: "top-center",
            autoClose: 2000,
          });
        }
      } else {
        setIsLoading(false);
        return toast.error("This Mail Does Not Exist", {
          position: "top-center",
          autoClose: 2000,
        });
      }
    } catch (e) {
      setIsLoading(false);
      return toast.error("Something went Wrong!", {
        position: "top-center",
        autoClose: 2000,
      });
    }
  };

  const handleVerifyOTP = async () => {
    try {
      if (!Otp) {
        return toast.error("Enter a proper code", {
          position: "top-center",
          autoClose: 2000,
        });
      }
      setIsLoading(true);
      const result = await authState.verifyOTP(Otp, email, "Login");
      if (result?.Error) {
        setIsLoading(false);
        return toast.error(result?.Error, {
          position: "top-center",
          autoClose: 2000,
        });
      } else {
        setIsLoading(false);
      }
    } catch (e) {
      setIsLoading(false);
      console.log(e);
    }
  };

  return (
    <div className="mx-auto w-full max-w-sm space-y-6">
      <div className="space-y-2 text-center">
        <h1 className="text-3xl font-bold">Welcome back</h1>
        <p className="text-muted-foreground">
          Login to your account to continue
        </p>
      </div>
      {!showOTP ? (
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              placeholder="m@example.com"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <Button
            onClick={handleSendOTP}
            className="w-full"
            disabled={isLoading}
          >
            {isLoading ? (
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            ) : (
              "Continue with Email"
            )}
          </Button>
        </div>
      ) : (
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="otp">Enter OTP sent to {email}</Label>
            <Input
              value={Otp}
              id="otp"
              type="number"
              required
              maxLength={4}
              onChange={(e) => SetOtp(e.target.value)}
            />
          </div>
          <Button
            type="button"
            variant="link"
            className="px-0 text-sm"
            onClick={() => setShowOTP(false)}
          >
            Change email
          </Button>
          <Button
            onClick={handleVerifyOTP}
            className="w-full"
            disabled={isLoading}
          >
            {isLoading ? (
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            ) : (
              "Verify OTP"
            )}
          </Button>
          <Button
            type="button"
            variant="link"
            className="w-full text-sm"
            onClick={handleSendOTP}
            disabled={isLoading}
          >
            Resend OTP
          </Button>
        </div>
      )}
      <p className="text-center text-sm text-muted-foreground">
        Don't have an account?{" "}
        <Link to="/brand/signup" className="underline underline-offset-2">
          Sign up
        </Link>
      </p>
    </div>
  );
}
